<div class="d-flex row-cols-12">
    <div class="col-12"><h3 class="title float-start" translate="Settings.Signing"></h3></div>
</div>

<div class="p-4 pt-0">
    <div class="pb-4 mb-3 d-table w-100 row-cols-12">
        <app-signing-methods [signatureMethodSettings]="signingMethodSettings" (updateOrganisationSettings)="updateValueFromSwitch($event)" ></app-signing-methods>
    </div>
    <div class="pb-4 d-table w-100 row-cols-12">
        <app-reasonlist [showReason]="locationReasonSettings.ShowReason" [reasons]="reasons" (AddReason)="addReason($event);" (RemoveReason)="removeReason($event);" (updateOrganisationSettings)="updateValueFromSwitch($event)" (reasonChangeOrder)="reasonChangeOrder($event)"></app-reasonlist>
    </div>
    <div class="pt-3 mb-3 d-table w-100 row-cols-12">
        <app-locationlist [showLocation]="locationReasonSettings.ShowLocation" [locations]="locations" (AddLocation)="addLocation($event);" (RemoveLocation)="removeLocation($event);" (updateOrganisationSettings)="updateValueFromSwitch($event)" (locationChangeOrder)="locationChangeOrder($event)"></app-locationlist>
    </div>
</div>